module.exports = __webpack_public_path__ + "static/media/8781.e7ef8529.png";